export const makeFetchCartContents = function(agent) {
    return async function fetchCartContents() {
        return await agent.get('/cart.json').json();
    };
};
